import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Message, FileUpload } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../service/account/account.service';
import { UploadFilesService } from '../../service/upload-files/upload-files.service';
import { PagesComponent } from '../pages.component';
import { config } from '../../../../../environments/config';
import { Router } from '@angular/router';

import { User } from '../../class/user';
import { Employee } from '../../class/employee';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

    public user: User;
    public edit = false;
    public editPass = false;
    public userEdit: User;
    public form: FormGroup;
    public formPassword: FormGroup;
    public email: AbstractControl;
    public language: AbstractControl;
    public current_password: AbstractControl;
    public password: AbstractControl;
    public confirmPassword: AbstractControl;
    public msgs: Message[] = [];
    public apiUrl = config.API_ROOT;
    public uploadedAvatar: any[] = [];
    public prewiewAvatar: any;
    public defaultAvatar: any;
    public avatar: any;
    public promiseSubmit: Promise<any>;
    public promiseAvatar: Promise<any>;
    public promisePass: Promise<any>;
    public langs= [
            {
                label: 'English', abr: 'en',
            },
            {
                label: 'Español', abr: 'es',
            },
        ];

    public employee: Employee;

    constructor(
        fb: FormBuilder,
        public accountService: AccountService,
        public uploadFilesService: UploadFilesService,
        public translate: TranslateService,
        public pagesComponent: PagesComponent,
        private _router: Router,
        ) {
        // this.form = fb.group({
        //     'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
        //     'email': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
        //     'language': [],
        // });

        // this.formPassword = fb.group({
        //     'current_password': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
        //     'password': ['', Validators.compose([Validators.required, Validators.minLength(6),Validators.pattern("^[a-zA-Z]+[0-9]+$")])],
        //     'confirmPassword': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
        // });

        // this.email = this.form.controls['email'];
        // this.language = this.form.controls['language'];

        // this.current_password = this.formPassword.controls['current_password'];
        // this.password = this.formPassword.controls['password'];
        // this.confirmPassword = this.formPassword.controls['confirmPassword'];

        this.defaultAvatar = require('../../../../../assets/images/Luciana.png');
        this.getProfile();
        // this.getProfilePermissions();
    }

    public modEdit(type: string) {
        this._router.navigate(['pages/account/edit' + '/' + type]);
        // this._router.navigate(['pages/account/edit'],{ queryParams: { 'email': this.user.email, 
        // 'language': this.user.language, 'userEdit': this.user, 
        // 'avatar': (this.user.avatar) ? this.user.avatar : this.defaultAvatar} });
        // this.edit = true;
        // this.email.setValue(this.user.email);
        // this.language.setValue(this.user.language);
        // this.userEdit = this.user;
        // this.avatar = (this.user.avatar) ? this.user.avatar : this.defaultAvatar;
    }

    public closeEditPass() {
        console.log('cancelEmployee');
        // this.password.setValue('');
        // this.current_password.setValue('');
        // this.confirmPassword.setValue('');
        // this.editPass = false;
        this._router.navigate(['pages/dashboard']);
    }
    
    public cancelEmployee(event) {
        this.edit = false
        this.getProfile();
    }
    public isEmployeeUser() {
        let user=JSON.parse(localStorage.getItem('profile'));
        if(user.employee_id)
            return true;
        return false;    
    }
    public getProfile() {
        this.accountService.getAccount().toPromise().then(
            response => {
                this.user = response.json();
                if(this.isEmployeeUser())
                    this.employee = this.user.employee;
                this.avatar = (this.user.avatar) ? this.user.avatar : this.defaultAvatar;
                // this.getAvatar();
            },
            error => {
                console.log(error.json());
            }
        );
    }

    // public getAvatar() {
    //     this.accountService.getAccountAvatar().toPromise().then(
    //         response => {
    //             this.avatar = response;
    //             console.log(response);
    //         },
    //         error => {
    //             console.log(error.json());
    //         }
    //     );
    // }

    public getProfilePermissions() {
        this.accountService.getAccountPermissions().toPromise().then(
            response => {
                this.user.permissions = response.json();
            },
            error => {
                console.log(error.json());
            }
        );
    }

    public updateProfile(values) {
        event.preventDefault();
        this.promiseSubmit = this.accountService.updateProfile(values).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.msgs = [];
                    this.msgs.push( { severity: 'success', summary: res  } );
                });
                this.getProfile();
                // this.pagesComponent.getAccount();
            },
            error => {
                let errorMsg = '';
                errorMsg = 'Error';
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: errorMsg  } );
            }
        );
    }

    public updatePassword(values) {
        event.preventDefault();
        const body = {
          'current_password': values.current_password,
          'new_password': values.password
        };
        this.promisePass = this.accountService.updatePassword(body).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.msgs = [];
                    this.msgs.push( { severity: 'success', summary: res  } );
                });
                this.closeEditPass();
            },
            error => {
                let errorMsg = '';
                if ( error.status === 422  ) {
                    this.translate.get('current password invalid').subscribe((res: string) => {
                        errorMsg = res;
                    });
                }
                if ( error.status === 500 ) {
                     errorMsg = 'Error';
                }
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: errorMsg  } );
            }
        );
    }

    public onUpload(event: any) {
        this.uploadedAvatar = [];
        for (const file of event.srcElement.files) {
            this.uploadedAvatar.push(file);
        }
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();
            reader.onload = () => {
              this.prewiewAvatar = reader.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    public updateAvatar(event: any) {
        this.promiseAvatar = this.uploadFilesService.updateAvatar(this.uploadedAvatar).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.msgs = [];
                    this.msgs.push( { severity: 'success', summary: res  } );
                });
                this.getProfile();
                this.avatar = this.prewiewAvatar;
            },
            error => {
                let errorMsg = '';
                errorMsg = 'Error';
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: errorMsg  } );
            }
         );
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/account/account.component.ts